import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;

  label {
    font-family: Sora, sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: #374151;
  }

  .option {
    display: flex;
    flex-direction: column;
    gap: 2px;

    strong {
      font-size: 13px;
      color: #101d40;
    }

    span {
      font-size: 12px;
      color: #4b5563;
      /* Descrições do convênio são longas: 2 linhas e reticências. */
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    small {
      font-size: 11px;
      color: #9ca3af;
    }
  }

  .field-error {
    font-size: 12px;
    color: #c53030;
  }

  .field-help {
    font-size: 12px;
    color: #6b7280;
  }
`;

export default Container;
